import { selectDates } from "core/times";
import { environment } from "@environment";
import context from "core/tv-guide.context";
import { ChannelData, EmptyItem, GenreSelectOption, GenreWithValue, ProgrammesAndDate, ScheduleDictionary, SelectOption } from "core/types";
import TvGuideStore from "core/providers/tv-guide.store";
import dateWrapper from "./date-wrapper";

const dictionary = context.dictionary;

export const createGenreOptions = (values: GenreWithValue[]) => {
  const getValue = (genre: GenreWithValue) => {
    if (genre.mainGenre === dictionary.allGenres || genre.mainGenre === "All Genres") {
      return "";
    }
    return genre.value || genre.mainGenre;
  }

  const genres: GenreSelectOption[] = values.map((genre) => ({
    label: genre.mainGenre,
    icon: "",
    iconLt: "",
    value: getValue(genre),
    subGenre: ""
  }));

  return genres;
}

export const createChannelOptions = (store: TvGuideStore) => {
  const channels: SelectOption[] = [];

  store.channelNumbers.forEach((channelNumber) => {
    const channelItem = store.channels[channelNumber];

    if (!channelItem) {
      return;
    }

    const darkLogo = channelItem.logo; //channelItem.channelLogoDark || channelItem.logo;
    const logo = channelItem.logo; //channelItem.channelLogo || channelItem.logo;

    const option: SelectOption = {
      label: `${channelItem.number}:${channelItem.name}`,
      icon: `${environment.imgUrlBase}${darkLogo}`,
      iconLt: `${environment.imgUrlBase}${logo}`,
      value: channelItem.number.toString()
    };

    channels.push(option);
  });

  return channels;
}

export const createPackageOptions = (store: TvGuideStore) => {
  const options: SelectOption[] = [];

  store.packages.forEach((pkg) => {
    const option = {
      label: pkg,
      icon: "",
      iconLt: "",
      value: pkg
    };

    options.push(option);
  });

  return options;
}

export const createDateOptions = () => {
  const options: SelectOption[] = [];

  selectDates.forEach(x => {

    let value = 1;

    const isWeek = x.includes("week");
    const replacement = isWeek ? "week" : "day";

    value = parseInt(x.replace(replacement, "").trim());

    if (isWeek) {
      value *= 7;
    }

    const option = {
      label: x,
      icon: "",
      iconLt: "",
      value: value.toString()
    };

    options.push(option);
  });

  return options;
}

export const programmeListBuilder = (dateRange: Date[], channel: number, progSchedule: ScheduleDictionary) => {
  const tempProgSchedule: ProgrammesAndDate[] = [];

  dateRange.forEach((dateItem) => {
    if (!progSchedule[channel]) {
      return;
    }

    const progArr = progSchedule[channel].programmes;

    const key = dateWrapper(dateItem).yearMonthDay();

    if (!progArr[key]) {
      return;
    }

    const item: ProgrammesAndDate = {
      date: dateItem.toDateString(),
      programmes: progArr[key]
    };

    tempProgSchedule.push(item);;
  });

  return tempProgSchedule;
}

export const channelDataAndProgrammeArrSet = (
  store: TvGuideStore,
  dateRange: string,
  setCurrentChannelData: (value: ChannelData) => void,
  setProgrammeArr: (value: ProgrammesAndDate[]) => void,
  setEmptyArr: (value: EmptyItem[]) => void
) => {
  if (!store.channelNumbers.includes(store.currentChannel)) {
    store.updateCurrentChannel(store.channelNumbers[0]);
  }

  const channelNumber = store.currentChannel;

  const channel = store.channels[channelNumber];

  const channelLogo = `${environment.imgUrlBase}${channel.logo}`;

  const channelData = {
    number: channel.number,
    tag: channel.tag,
    name: channel.name,
    imgSrc: channelLogo,
    imgSrcLt: channelLogo
  };

  setCurrentChannelData(channelData);

  if (!store.hasScheduleData) {
    return;
  }

  let value = 1;

  const isWeek = dateRange.includes("week");
  const replacement = isWeek ? "week" : "day";

  value = parseInt(dateRange.replace(replacement, "").trim());

  if (isWeek) {
    value *= 7;
  }

  const programmes = programmeListBuilder(
    store.dates.slice(0, value),
    store.currentChannel,
    store.schedule
  );

  setProgrammeArr(programmes);

  const emptyList = [];
  const emptyLength = 4;

  for (let i = 0; i < emptyLength; i++) {
    const empty = i < emptyLength ? "loader" : "item";
    emptyList.push({ empty });
  }

  setEmptyArr(emptyList);
}
